var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"as-code-editor",style:({
    '--height': _vm.height,
    '--minHeight': _vm.minHeight,
    '--maxHeight': _vm.maxHeight,
  })},[_c('textarea',{ref:"asCodeEditor",attrs:{"type":"textarea"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }